export default "__VITE_ASSET__5c84cd68__"